import React from 'react';

import { AgreementIcons } from '../../../store/catalogs/AgreementsIcons';
import { ReactComponent as TwoSheets } from '../../../assets/icons/TwoSheets.svg';

import classes from './CardAgreement.module.scss';

const CardAgreement = ({ category, categorySelected, onClick }) => {
  return (
    <div
      onClick={() => onClick(category)}
      className={`${categorySelected?.value === category.value ? classes['card-selected'] : classes['card-not-selected']} ${
        classes.card
      } pointer `}>
      {!!AgreementIcons[category.value]?.icon ? AgreementIcons[category.value].icon : <TwoSheets />}
      {/* <span title={category.label} className='semibold-16 text-ellipsis'>
        {category.label}
      </span> */}
      <span title={category.label} className={classes.label}>
        {category.label}
      </span>
    </div>
  );
};

export default CardAgreement;
